
import CustomeIcon from "../components/CustomeIcon";

const Header = () => {
    return (
        <header className='header'>
            <CustomeIcon src='./images/sharpLogo.svg' alt='Sharp Logo' classList='logo'></CustomeIcon>
        </header>
    );
  }
  
  export default Header;